import { render, staticRenderFns } from "./CourseProject.vue?vue&type=template&id=45ff6232&scoped=true&"
import script from "./CourseProject.vue?vue&type=script&lang=js&"
export * from "./CourseProject.vue?vue&type=script&lang=js&"
import style0 from "./CourseProject.vue?vue&type=style&index=0&id=45ff6232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ff6232",
  null
  
)

export default component.exports